import { render, staticRenderFns } from "./principal-recovery.vue?vue&type=template&id=449a67bc"
import script from "./principal-recovery.vue?vue&type=script&lang=ts"
export * from "./principal-recovery.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports